import { defineMessage } from 'services/localization';

export const messages = {
    title: defineMessage('overwrite_the_go_to_button_in_xero'),
    subtitle: defineMessage('approvalmax_can_add_a_g_its_used_by_another_app'),
    optionYes: defineMessage('yes_rewrite_the_button'),
    optionNo: defineMessage('no_do_not_rewrite_the_button'),
};
